import declare from "dojo/_base/declare";
import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import csi from "csi/main";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import Query from "csi/xml/Query";

const MassColorAllocationWizard = declare([Controller, ActionControllerMixin], {
	idWizardResource: "MassColorAllocationWizard",
	_fdPage1: null,
	_fdPage2: null,

	/**
	 * @override
	 * Disable finish button
	 */
	disableFinish: function (wizard, page, index) {
		return index == 0 || !(this._fdPage2.getSelectedNodes().length > 0);
	},

	/**
	 * @Override
	 * Disable Next button if no selections
	 */
	disableNext: function(wizard, page, index) {
		return index == 0 && !(this._fdPage1.getSelectedNodes().length > 0);
	},

	/**
	 * @override
	 * Pass data into the next page
	 */
	onNextPage: function(wizard, currentPage, nextPage, bFinish) {
		let fd = this.m_formData;
		const indexOfPage = wizard.getIndexOfPage(nextPage);
		if (indexOfPage == 0) {
			fd = this._fdPage1 = this._fdPage1 || new FormData(this);
		} else if (indexOfPage == 1) {
			fd = this._fdPage2 = this._fdPage2 || this.m_formData;
		}
		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, false) : null;
	},

	/**
	 * @override
	 * Add the colors and materials to the call
	 */
	toWriterRequest: function () {
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("Colors", xml.ATTR_REFLIST, this._fdPage1.getSelectedValue());
		call.addParameter("Materials", xml.ATTR_REFLIST, this._fdPage2 .getSelectedValue());
		return call;
	},

	/**
	 * @override
	 * Filter out materials that doesn't have color
	 */
	getWizardViewQuery: function(wizard, view, index) {
		if (index == 0) {
			return new Query().Attr("Active", xml.OP_EQUALS, true)
				.Attr("OKForMaterial", xml.OP_EQUALS, true)
				.RefAttr("MergedTo", xml.OP_EQUALS, csi.EMPTY_URL);
		} else if (index == 1) {
			const query = new Query();
			query.Attr("HasColor", xml.OP_EQUALS, true, "Child:ProductType/Child:ProductionConfig");
			const qOr = query.Or();
			qOr.Attr("ColorPaletteRule", xml.OP_EQUALS, "ColorPaletteRuleTypes:Enabled", "Child:ProductType/Child:ProductionConfig");
			qOr.Attr("ColorPaletteRule", xml.OP_EQUALS, "ColorPaletteRuleTypes:Enforced", "Child:ProductType/Child:ProductionConfig");
			return query;
		}
		return null;
	},

});

export = MassColorAllocationWizard;
